import * as React from 'react';

const CooltraOntinyentLogo = ({
  width = 180,
  height = 54,
  alt = 'Cooltra Ontinyent'
}: React.ImgHTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      width={width}
      height={height}
      src="/static/assets/ontibiciLogo.svg"
      alt={alt}
    />
  );
};

export default CooltraOntinyentLogo;
